import module from 'finanzas/module.js'
import template from './template.html'
// import { groupBy, orderBy } from 'lodash'
//
// const diacriticosRegex = /[\u0300-\u036f]/g
// const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').toUpperCase()


// export class FinancesPosicionbancariaSaldosListaComponent {
//   filtro
//   fechaFinal
//   estatusCuenta
//   divisa
//
//   constructor (FinancesPosicionbancariaSaldos, FinancesPosicionbancariaDivisas, $q, $filter, $export) {
//     this.$q = $q
//     this.$export = $export
//     // this.filterBy = $filter('filterBy')
//     // this.groupBy = $filter('groupBy')
//     // this.orderBy = $filter('orderBy')
//     this.FinancesPosicionbancariaSaldos = FinancesPosicionbancariaSaldos
//     this.FinancesPosicionbancariaDivisas = FinancesPosicionbancariaDivisas
//   }
//
//   $onInit () {
//     this.$promise = this.$q.all([
//       this.FinancesPosicionbancariaSaldos.get(this.fechaFinal.toYMD(), this.estatusCuenta)
//         .then(({data}) => {
//           this.data = data.map(i => {
//             i.busqueda = normalizar(`${i.empresa}|${i.banco}|${i.numero_cuenta}|${i.moneda}|${i.id_banco}`)
//             return i
//           })
//
//           this.data = orderBy(this.data, ['empresa', 'banco', 'cuenta'])
//         }),
//       this.FinancesPosicionbancariaDivisas.get()
//         .then(({data}) => (this.divisa = parseFloat(data))),
//     ]).then(() => {
//       this.calcularTotales()
//       this.filtrar()
//     })
//   }
//
//   filtrar () {
//     let filtro = normalizar(this.filtro)
//     let resultados = this.data
//
//     if (this.filtro) {
//       resultados = resultados.filter(i => {
//         return i.busqueda.includes(filtro)
//       })
//     }
//
//
//     this.resultados = resultados
//     this.resultadosOcultos = this.data.length - resultados.length
//     this.resultadosAgrupados = groupBy(resultados, 'empresa')
//   }
//
//   calcularTotales () {
//     this.totales = {
//       dolares: 0,
//       pesos: 0,
//       cheques_dolares: 0,
//       cheques_pesos: 0,
//       total: 0,
//     }
//
//     this.data.forEach(item => {
//       this.totales.dolares += item.id_moneda === '2' ? item.saldo : 0
//       this.totales.pesos += item.id_moneda === '1' ? item.saldo : 0
//       this.totales.cheques_dolares += item.id_moneda === '2' ? item.transito : 0
//       this.totales.cheques_pesos += item.id_moneda === '1' ? item.transito : 0
//     })
//
//     this.totales.total = (this.totales.dolares * this.divisa) + this.totales.pesos - (this.totales.cheques_dolares * this.divisa) - (this.totales.cheques_pesos * this.divisa)
//   }
//
//   exportar () {
//     this.$export.excel('Posición Bancaria', [new this.Pagecuentas(this.data)])
//   }
//
//   Pagecuentas (cuentas) {
//     return {
//       name: 'Empleados',
//       columns: [
//         {label: 'Empresa', format: {width: 50}},
//         {label: 'Banco', format: {align: 'center', width: 15}},
//         {label: 'Cuenta', format: {width: 10}},
//         {label: 'Moneda', format: {width: 10}},
//         {label: 'Saldos en Banco', format: {type: 'currency', align: 'right', width: 12}},
//         {label: 'Partidas en tránsito', format: {type: 'currency', align: 'right', width: 12}},
//         {label: 'Cheques Retenidos', format: {type: 'currency', align: 'right', width: 12}},
//         {label: 'Saldo Disponible', format: {type: 'currency', align: 'right', width: 12}},
//         {label: 'Saldo Modificado', format: {type: 'currency', align: 'right', width: 12}},
//       ],
//       options: {
//         logo: {
//           filename: '/api/export/images/FAN-logo.png',
//           title: 'FAN Consultores',
//           cell: 'A1',
//         },
//         show_grid: false,
//         fixed_column: 'A8',
//       },
//       data: cuentas.map(function (row) {
//         return [
//           row.empresa,
//           row.banco,
//           row.numero_cuenta,
//           row.moneda,
//           row.saldo,
//           row.transito,
//           row.retenido,
//           row.saldo - row.transito,
//           row.saldo - row.transito - row.prestamos,
//         ]
//       }),
//     }
//   }
// }

function FinancesPosicionbancariaSaldosListaComponent (FinancesPosicionbancariaSaldos, FinancesPosicionbancariaDivisas, $q, $filter, $export) {
  var $ctrl = this,
    filterBy = $filter('filter'),
    groupBy = $filter('groupBy'),
    orderBy = $filter('orderBy')

  $ctrl.$onInit = $onInit
  $ctrl.filtrar = filtrar
  $ctrl.exportar = exportar

  function $onInit () {
    $ctrl.filtro = undefined
    $ctrl.$promise = $q.all([
      FinancesPosicionbancariaSaldos.get($ctrl.fechaFinal.toYMD(), $ctrl.estatusCuenta)
        .then(function (response) {
          $ctrl.data = orderBy(response.data, ['empresa', 'banco', 'cuenta'])
        }),
      FinancesPosicionbancariaDivisas.get()
        .then(function (response) {
          $ctrl.divisa = parseFloat(response.data)
        }),
    ])
      .then(function () {
        calcularTotales()
        filtrar()
      })
  }

  function filtrar () {
    var resultados = $ctrl.data

    if ($ctrl.filtro)
      resultados = filterBy(resultados, $ctrl.filtro)

    $ctrl.resultados = resultados
    $ctrl.resultadosOcultos = $ctrl.data.length - resultados.length
    $ctrl.resultadosAgrupados = groupBy(resultados, 'empresa')
  }

  function calcularTotales () {
    $ctrl.totales = {
      dolares: 0,
      pesos: 0,
      cheques_dolares: 0,
      cheques_pesos: 0,
      total: 0,
    }

    $ctrl.data.forEach(function (item) {
      $ctrl.totales.dolares += item.id_moneda === '2' ? item.saldo : 0
      $ctrl.totales.pesos += item.id_moneda === '1' ? item.saldo : 0
      $ctrl.totales.cheques_dolares += item.id_moneda === '2' ? item.transito : 0
      $ctrl.totales.cheques_pesos += item.id_moneda === '1' ? item.transito : 0
    })
    $ctrl.totales.total = ($ctrl.totales.dolares * $ctrl.divisa) + $ctrl.totales.pesos - ($ctrl.totales.cheques_dolares * $ctrl.divisa) - ($ctrl.totales.cheques_pesos * $ctrl.divisa)
  }

  function exportar () {
    $export.excel('Posición Bancaria', [new Pagecuentas($ctrl.data)])
  }

  function Pagecuentas (cuentas) {
    return {
      name: 'Empleados',
      columns: [
        {label: 'Empresa', format: {width: 50}},
        {label: 'Banco', format: {align: 'center', width: 15}},
        {label: 'Cuenta', format: {width: 10}},
        {label: 'Moneda', format: {width: 10}},
        {label: 'Saldos en Banco', format: {type: 'currency', align: 'right', width: 12}},
        {label: 'Partidas en tránsito', format: {type: 'currency', align: 'right', width: 12}},
        {label: 'Cheques Retenidos', format: {type: 'currency', align: 'right', width: 12}},
        {label: 'Saldo Disponible', format: {type: 'currency', align: 'right', width: 12}},
        {label: 'Saldo Modificado', format: {type: 'currency', align: 'right', width: 12}},
      ],
      options: {
        logo: {
          filename: '/api/export/images/FAN-logo.png',
          title: 'FAN Consultores',
          cell: 'A1',
        },
        show_grid: false,
        fixed_column: 'A8',
      },
      data: cuentas.map(function (row) {
        return [
          row.empresa,
          row.banco,
          row.numero_cuenta,
          row.moneda,
          row.saldo,
          row.transito,
          row.retenido,
          row.saldo - row.transito,
          row.saldo - row.transito - row.prestamos,
        ]
      }),
    }
  }
}

module.component('financesPosicionbancariaSaldosLista', {
  controller: FinancesPosicionbancariaSaldosListaComponent,
  template,
  bindings: {
    fechaFinal: '<',
    estatusCuenta: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/posicionbancaria/saldos/lista/component.js